export default __webpack_public_path__ + "static/media/img (1).eae28f9f.jpg";